<div class="error-screen">
  <mat-icon svgIcon="{{errorMsg.iconName}}"></mat-icon>
  <div class="text-container">
    <span class="title">{{errorMsg.title}}</span>
    <span class="subtitle">{{errorMsg.text}}</span>
    <button (click)='onClick()' id="btn-error-component" mat-raised-button color="primary02" class="sm"
      *ngIf="!hiddenButtonLogin">
      {{errorMsg.buttonText}}
    </button>
  </div>
</div>